import axios from 'axios';

export const digestPdfIAMSmart = (fileId, fileType) =>
  axios.post('/ess/api/sign/deferred-hash/i-am-smart', {
    fileID: fileId
  });

export const digestNonPdfIAMSmart = (fileId) =>
  axios.post('/ess/api/sign/non-pdf-hash/i-am-smart', {
    fileID: fileId
  });

export const digestNormalPdfIAMSmart = (fileId) =>
  axios.post('/ess/api/sign/normal-pdf-hash/i-am-smart', {
    fileID: fileId
  });

export const digestBAForm = (fileId, section) =>
  axios.post('/ess/api/sign/deferred-hash/ba-form', {
    file: {
      fileID: fileId
    },
    section: {
      name: section
    }
  });

  export const digestBAFormIAMSmart = (fileId, section) =>
  axios.post('/ess/api/sign/deferred-hash/ba-form/i-am-smart', {
    file: {
      fileID: fileId
    },
    section: {
      name: section
    }
  });

export const getBAFormSignSelections = (fileID) =>
  axios.get(`/ess/api/sign/${fileID}/ba-form-sign-selections`);

export const removeSignature = (fileID) =>
  axios.delete(`/ess/api/sign/${fileID}/remove-sign-record`);

export const getSigningClientDownloadPath = () => axios.get(`/api/systemsetting/module/0ceb612e-77bc-4b0e-9cd9-c02ef891fba7/public?keys=SignClientVersion&keys=SignClientURL`);